import { render, staticRenderFns } from "./LmPortalTarget.vue?vue&type=template&id=402c966e&"
import script from "./LmPortalTarget.vue?vue&type=script&lang=js&"
export * from "./LmPortalTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports